/* -------------------------------------------------------------------------- */
/*                               Schema Workplans                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const workplan = new schema.Entity('workplans', {}, { idAttribute: 'workplanId' });
export const workplans = new schema.Array(workplan);
